module.exports = __webpack_public_path__ + "static/media/logo.4cd11d9b.png";